module.exports = __webpack_public_path__ + "static/media/airplane-icon.78919e92.png";